import { QueryClient } from '@tanstack/react-query';

// Shared TanStack Query client.
// Tuned for an internal CRM: data doesn't change every second, but we DO want
// other users' edits to show up reasonably soon (within ~30s or whenever the
// user refocuses the tab).
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30 * 1000,         // 30 sec — accept slightly stale data
            gcTime: 30 * 60 * 1000,       // keep unused cache for 30 min
            refetchOnWindowFocus: true,   // when you tab back in, get fresh data
            refetchOnReconnect: true,
            retry: 1,
        }
    }
});

// Canonical query keys — used across hooks and prefetch helpers.
// Anywhere we use a string literal for a queryKey, it should be in this list.
export const QUERY_KEYS = {
    useCases:     ['useCases'],
    competitions: ['competitions'],
    gtmAccounts:  ['gtmAccounts'],
    deals:        ['deals'],
    activities:   ['activities'],
    investors:    ['investors'],
    partnerships: ['partnerships'],
    internal:     ['internal'],
    externalContacts: ['externalContacts'],
};
